import BaseApi from '@/api/Base/BaseApi'
import { CommonListPayload } from '@/api/DatasetNode/types'
import { PerformanceTaskComparisonResponse } from '@/api/ModelPerformance/types'
import {
  ModelRetrainEvaluationNodeInfo,
  UpdateModelRetrainEvaluationNodePayload,
  PerformanceResult,
  GetSelectedCheckpointResponse,
  ChangeRetrainThresholdPayload
} from '@/api/ModelRetrainEvaluationNode/types'

const ROOT = '/model-retrain-evaluation'

export default class ModelRetrainEvaluationNodeApi extends BaseApi {
  getModelRetrainEvaluationNodeDetail(modelRetrainEvaluationNodeId: string) {
    return this.agent.get<ModelRetrainEvaluationNodeInfo>(`${ROOT}/${modelRetrainEvaluationNodeId}`)
  }

  exportModel(payload: any) {
    const { modelRetrainEvaluationNodeId, isExportNewModel } = payload
    return this.agent.post(`${ROOT}/${modelRetrainEvaluationNodeId}/export`, { isExportNewModel })
  }

  updateModelRetrainEvaluationNode(payload: UpdateModelRetrainEvaluationNodePayload) {
    const { modelRetrainEvaluationNodeId, name, ...rest } = payload
    return this.agent.put(`${ROOT}/${modelRetrainEvaluationNodeId}`, { ...rest, name: name?.trim() })
  }

  getSelectedCheckpoint(modelRetrainEvaluationNodeId: string) {
    return this.agent.get<GetSelectedCheckpointResponse>(`${ROOT}/${modelRetrainEvaluationNodeId}/selected-checkPoint`)
  }

  getSelectedTasks(modelRetrainEvaluationNodeId: string) {
    return this.agent.get<PerformanceResult[]>(`${ROOT}/${modelRetrainEvaluationNodeId}/selected-tasks`)
  }

  postModelRetrainEvaluationNodeSelectedTasks(payload: any) {
    const { modelRetrainEvaluationNodeId, ...rest } = payload
    return this.agent.post<any>(`${ROOT}/${modelRetrainEvaluationNodeId}/selected-tasks`, rest)
  }

  getModelRetrainTaskComparison(modelRetrainEvaluationNodeId: string, options: CommonListPayload & { search?: string }) {
    const {
      itemsPerPage,
      page,
      sortDir,
      sortKey,
      search,
    } = options

    return this.agent.get<PerformanceTaskComparisonResponse>(`${ROOT}/${modelRetrainEvaluationNodeId}/task-comparison`, {
      params: {
        search,
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
      },
    })
  }

  changeRetrainThreshold(payload: ChangeRetrainThresholdPayload) {
    const { modelRetrainEvaluationNodeId, ...rest } = payload
    return this.agent.put(`${ROOT}/${modelRetrainEvaluationNodeId}/threshold`, rest)
  }

  finalizeRetrainThreshold(modelRetrainEvaluationNodeId: string) {
    return this.agent.post(`${ROOT}/${modelRetrainEvaluationNodeId}/finalize-threshold`)
  }
}
